<template>
  <div class="container-fluid">
    <div class="heightcontainer">
      <landing-navbar></landing-navbar>
        <section class="section1 mt-2 pb-5 backgroundcolor10">
          <div class="container row pb-5 pt-5 no-gutters mx-auto ">
                <div class="col-12 mt-5 pb-lg-5 pt-lg-5">
                    <div class="col-lg-12 mt-lg-5 text-center section1content">
                        <div class="vertical-center mt-lg-5 top-padding pl-md-3 pr-md-3">   
                          <h2 class="font48-bold-main proximanova-bold">Here’s how it works?</h2>    
                          <p class="font24-reg-main pl-md-3 pr-md-3 mt-4 proximanova">{{howWorknotionWorksContent}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section2 d-flex mx-auto justify-content-between">
            <ul class="events col-md-12 col-lg-10 mx-auto">
                <li>
                    <div class="col-md-6 pb-md-5">
                    </div>
                    <span class="aftercontent col-md-6 pb-5">
                    </span>
                </li>
                <li>
                    <div class="leftContent left01 col-md-6 pb-md-5">
                        <div class="d-flex flex-column pt-4 pt-md-0 text-md-right">
                            <h2 class="font36-bold-main black proximanova-bold">Sign up</h2>                     
                            <p class="font24-reg-main mt-2 mt-md-4 mb-1 proximanova ">Create an account on Worknotion. Simply fill in the required information, verify your identity and you’re good to go.</p>
                        </div>
                    </div>
                    <span class="aftercontent col-md-6 pb-5">
                        <div class="d-flex flex-column pl-2 pr-2 pl-md-0 pr-md-0">
                            <div class="numberStyles text-center d-none d-md-block">01</div>
                            <img src="../../assets/howitworksimg1.webp" class="img-fluid negMargin shadow borderradius20 mb-3 mb-md-5" alt="howitworks">
                        </div>
                    </span>
                </li>
                <li>
                    <span class="leftContent left02 col-md-6 pb-md-5">
                        <div class="d-flex flex-column pl-2 pr-2 pl-md-0 pr-md-0">
                            <div class="numberStyles text-center d-none d-md-block">02</div>
                            <img src="../../assets/howitworksimg2.webp" class="img-fluid col-lg-10 pl-0 pr-0 shadow borderradius20 mb-3 mb-md-5" alt="howitworks">
                        </div>
                    </span>
                    <div class="aftercontent col-md-6 pb-5">
                        <div class="d-flex flex-column text-left">
                            <h2 class="font36-bold-main black proximanova-bold">Follow influencers / businesses</h2>                     
                            <p class="font24-reg-main mt-2 mt-md-4 mb-1 proximanova">Subscribe to posts from individuals/ influencers already on the platform and stay updated on what’s happening in your field. </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="leftContent left03 col-md-6 pb-md-5">
                        <div class="d-flex flex-column text-md-right">
                            <h2 class="font36-bold-main black proximanova-bold">Create a Video Resume/Upload one</h2>                     
                            <p class="font24-reg-main mt-2 mt-md-4 mb-1 proximanova">Worknotion is all about video interactions. Upload an existing video resume or create one on the platform and you’re ready to start.</p>
                        </div>
                    </div>
                    <span class="aftercontent col-md-6 pb-5">
                        <div class="d-flex flex-column pl-2 pr-2 pl-md-0 pr-md-0">
                            <div class="numberStyles text-center d-none d-md-block">03</div>
                            <img src="../../assets/howitworksimg3.webp" class="img-fluid negMargin shadow borderradius20 mb-5" alt="howitworks">
                        </div>
                    </span>
                </li>
                <li>
                    <span class="leftContent left04 col-md-6 pb-md-5">
                        <div class="d-flex flex-column pl-2 pr-2 pl-md-0 pr-md-0">
                            <div class="numberStyles text-center d-none d-md-block">04</div>
                            <img src="../../assets/howitworksimg4.webp" class="img-fluid col-lg-10 pl-0 pr-0 shadow borderradius20 mb-2 mb-md-5" alt="howitworks">
                        </div>
                    </span>
                    <div class="aftercontent col-md-6 pb-5">
                        <div class="d-flex flex-column text-left">
                            <h2 class="font36-bold-main black proximanova-bold">Apply to your favorite job</h2>                     
                            <p class="font24-reg-main mt-2 mt-md-4 mb-1 proximanova">Follow businesses and get alerts on prospective growth opportunities. Apply to the one you find the most lucrative</p>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="leftContent left05 col-md-6 pb-md-5">
                        <div class="d-flex flex-column text-md-right">
                            <h2 class="font36-bold-main black proximanova-bold">Track your Job Application</h2>                     
                            <p class="font24-reg-main mt-2 mt-md-4 mb-1 proximanova">Track the status of your job application from within the platform to stay updated with timely alerts.</p>
                        </div>
                    </div>
                    <span class="aftercontent col-md-6 pb-md-5">
                        <div class="d-flex flex-column pb-5 pl-2 pr-2 pl-md-0 pr-md-0">
                            <div class="numberStyles text-center d-none d-md-block">05</div>
                            <img src="../../assets/howitworksimg5.webp" class="img-fluid negMargin shadow borderradius20 mb-md-5" alt="howitworks">
                        </div>
                    </span>
                </li>
                <li>
                    <span class="leftContent left04 col-md-6 pb-md-5">
                        <div class="d-flex flex-column pl-2 pr-2 pl-md-0 pr-md-0">
                            <div class="numberStyles text-center d-none d-md-block">06</div>
                            <img src="../../assets/howitworksimg6.webp" class="img-fluid col-lg-10 pl-0 pr-0 shadow borderradius20 mb-2 mb-md-5" alt="howitworks">
                        </div>
                    </span>
                    <div class="aftercontent col-md-6 pb-5">
                        <div class="d-flex flex-column text-left">
                            <h2 class="font36-bold-main black proximanova-bold">Build a Professional Network</h2>                     
                            <p class="font24-reg-main mt-2 mt-md-4 mb-1 proximanova">Record and post short videos on your profile timeline. Stir discussions and invite users to join the same. Build professional business relationships so there's nothing stopping you.</p>
                        </div>
                    </div>
                </li>
            </ul>
        </section> 
    </div>    
    <Footer class="footer" ></Footer>
  </div> 
</template>
<script>
import BottomFooter from "@/components/BottomFooter.vue";
import Footer from '../LandingFooter.vue'
import router from '../../router.js'
import LandingNavbar from './Navbar.vue'
import wndata from '../../js/wn_data.json'
import $ from 'jquery'
export default {
  components: {
    BottomFooter,   
    Footer,
    LandingNavbar
  },
  data() {
    return {
      newpassword: "Enter New Password",
      confirmpassword: "Enter Confirm Password *",
      newpassword: "",
      cpassword: "",
      show: false,
      signup: "Candidate",
      Candidate: "Candidate",
      Recruiter: "Recruiter",
      verificationdetails: true,
      terms: false,
      message: "",
      getotpdetails: false,
      emailidverification: true,
      isVideoPlaying : false,
      howWorknotionWorksContent : "Building a professional network was never this easy! Be a part of the world’s largest and ever-growing platform that helps both job-seekers and businesses alike. It’s time to take on the lead and outshine the competition.",
    };
  },
  methods: {
    NavToSignup() {
      router.push({
        name : 'signup'
      })
    },
    play_follow() {
      var video = document.getElementById('videoTag')
      this.isVideoPlaying = !this.isVideoPlaying
      if(this.isVideoPlaying){
        video.play()
      }else{
        video.pause()
      }
    },
    switchVisibility() {
      const passwordField = document.querySelector("#password");
      if (passwordField.getAttribute("type") === "password")
        passwordField.setAttribute("type", "text");
      else passwordField.setAttribute("type", "password");
    },
    emailidverified() {
      this.message = "EmailIDVerified";
      if (this.message === "EmailIDVerified") {
        this.verificationdetails = true;
        this.getotpdetails = true;
        this.emailidverification = false;
      }
    },
    toggle() {
      this.show = !this.show;
    },
    backtosignup() {
      this.getotpdetails = false;
      this.verificationdetails = true;
      this.message = "";
    },
    NavToBusinessAccount(){
      var x = document.createElement('a')
      x.target = '_blank'
      x.href = wndata.companyAccountWebapp
      x.click()
    },
    NavToPricing() {
        router.push({
            name : 'pricing'
        })
    },
    getotp() {
      this.message = "gotOTP";
      if (this.message === "gotOTP") {
        this.verificationdetails = false;
        this.getotpdetails = true;
      }
    }
  },
  mounted: function() {
    window.scrollTo(0, 0)
  },
  computed: {
    isDisabled: function() {
      return !this.terms;
    }
  }
};
</script>
<style scoped>
.events li {
    list-style-type: none;
}
.button-create{
  font-size: 18px !important;
}
.button-create:focus {
  outline: 0 !important;
}
.videocard{
  background: black;
  border-radius: 20px;
  padding: 25px 0;
}
#videoTag{
  width: 100%;
  /* background-image: linear-gradient(rgba(31, 31, 31, .1), rgba(31,31,31,.1)), url(''); */
}
.landingElementStyles{
  width: 150px;
  position: absolute;
  margin-top: -90px;
  z-index: 1;
}
.zindex1{
  z-index: 1 !important;
}
.zindex2{
  z-index: 2 !important;
}
.gradientColor1{
  background: -webkit-linear-gradient(rgb(27, 140, 233), rgb(147, 209, 209), rgb(2, 61, 61)) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
.gradientColor2{
  background: -webkit-linear-gradient(#12c2e9, #c471ed, #f7797d) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
.gradientColor3{
  background: -webkit-linear-gradient(rgb(182, 44, 20), rgb(209, 203, 147), rgb(63, 175, 12)) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
#playvideobtn{
  margin-top: 60px !important;
}
.pausebtn{
  display: none;
  margin-top: 60px !important;
  margin-left: 44% !important;
}
.videocard:hover .pausebtn{
  display: block;
  margin-top: 75px !important;
}
.font36-bold-main{
    font-size: 36px !important;
}
@media (min-width: 992px){
  .containerfluidcontent{
    width: 85% !important;
  }
  .whatpeoplesayCard{
    position: absolute;
    z-index: 2;
    margin-top: 8%;
  }
  #videoTag{
    height: 460px !important;
  }
  #playvideobtn{
    margin-top: 200px !important;
  }
  .pausebtn{
    display: none;
    margin-top: 220px !important;
    margin-left: 48% !important;
  }
  .videocard:hover .pausebtn{
    display: block;
    margin-top: 215px !important;
  }
  .negMargin{
    margin-left: -150px !important;
    z-index: 4;
    }
}
section {
 margin: 0 0 0rem 0rem  !important ;
}
.footer {
  background-color: black;       
  color : white;
  position: sticky;
}
.top-padding{
  padding-top:3rem !important;
}
h2{
  font-weight: 300;
}
.section1 {
  background-color:white;
}
.section2 {
  background-color:white;
}   
@media screen and (min-width: 300px) and (max-width: 350px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font24-reg-main{
    font-size: 16px;
  }
  .font48-bold-main {	
    font-size: 24px;	
  }
  .font40-bold-main{
    font-size: 20px;
  }
}
@media screen and (min-width: 350px) and (max-width: 400px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font24-reg-main{
    font-size: 16px;
  }
  .font48-bold-main {	
    font-size: 24px;	
  }
  .font40-bold-main{
    font-size: 20px;
  }
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .section1content{
    margin-top: 12% !important;
  }
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .section1content{
    margin-top: 12% !important;
  }
  #playvideobtn{
    margin-top: 160px !important;
  }
  .pausebtn{
    display: none;
    margin-top: 160px !important;
    margin-left: 46% !important;
  }
  .videocard:hover .pausebtn{
    display: block;
    margin-top: 175px !important;
  }
}
@media screen and (min-width: 400px) and (max-width: 600px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font48-bold-main {	
    font-size: 28px;	
  }
  .font40-bold-main{
    font-size: 24px;
  }
  .font24-reg-main {
    font-size: 18px;
  }
}
@media screen and (max-width: 900px) and (min-width: 800px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 700px) and (min-width: 600px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 800px) and (min-width: 700px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (min-width: 600px){
    .events li { 
        display: flex; 
        color: #999;
    }
    .numberStyles{
        /* font-size: 50px; */
        font-size: 10rem;
        color: #999696;
        opacity: .2;
        font-weight: bold;
    }
    .events .leftContent { 
        position: relative;
        padding: 0 1.5em;  
    }
    .events .leftContent::after { 
        content: "";
        position: absolute;
        z-index: 2;
        right: 0;
        top: 0;
        transform: translateX(50%);
        border-radius: 50%;
        background: #fff;
        border: 2px #ccc solid;
        width: 2.5em;
        height: 2.5em;
    }

    .left01::after{
        border: 4px solid #BF6B6B !important;
        background: #F4B6B6 !important;
    }
    .left02::after{
        border: 4px solid #0C8CAE !important;
        background: #C2E8F6 !important;
    }
    .left03::after{
        border: 4px solid #5E3082 !important;
        background: #E1B8F2 !important;
    }
    .left04::after{
        border: 4px solid #498A45 !important;
        background: #B8E6A2 !important;
    }
    .left05::after{
        border: 4px solid #7D3B10 !important;
        background: #F4CC95 !important;
    }
    .events .aftercontent {
        padding: 0 1.5em 1.5em 1.5em;
        position: relative;
    }

    .events .aftercontent::before {
        content: "";
        position: absolute;
        z-index: 1;
        /* left: 0; */
        left: -1px;
        height: 100%;
        border-left: 5px #ccc dashed;
    }
    .events strong {
        display: block;
        font-weight: bolder;
    }

    .events { margin: .2em; width: 50%; }
    .events, 
    .events *::before, 
    .events *::after { box-sizing: border-box; font-family: arial; }
}
</style>
